import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Estilos } from '../../../services/estilos/estilos';

export interface DialogData {
  url: string;
}

@Component({
  selector: 'lib-dialog-base',
  templateUrl: './dialog-place-2-pay.component.html',
  styleUrls: ['./dialog-place-2-pay.component.css']
})
export class DialogPlace2payComponent {

  url: string

  constructor(
    public dialogRef: MatDialogRef<DialogPlace2payComponent>,
    private elementRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.url = this.data.url
  }

  closeModal() {
    this.dialogRef.close('cerrarModal')
  }
  
}
